import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import userService from './userService'

// Get users
export const getUsers = createAsyncThunk('user/user-list', async (params: {}, thunkAPI) => {
  try {
    return await userService.getUsers({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create user
export const createUser = createAsyncThunk('user/create', async (user: {}, thunkAPI) => {
  try {
    return await userService.createUser({user})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get user by id
export const getUserById = createAsyncThunk('user/get-user', async (id: string, thunkAPI) => {
  try {
    return await userService.getUserById(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user
export const updateUser = createAsyncThunk('user/update', async (user: {}, thunkAPI) => {
  try {
    return await userService.updateUser({user})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete user
export const deleteUser = createAsyncThunk('user/delete', async (user_id: string, thunkAPI) => {
  try {
    return await userService.deleteUser(user_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user password
export const updateUserPassword = createAsyncThunk(
  'user/update-password',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.updateUserPassword({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetLecturerUsers = createAsyncThunk('lecturer-users', async (params: {}, thunkAPI) => {
  try {
    return await userService.getLecturerUsers({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStduentUsers = createAsyncThunk('student-users', async (params: {}, thunkAPI) => {
  try {
    return await userService.getStduentUsers({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SetUserLanguage = createAsyncThunk('set-lang', async (id: string, thunkAPI) => {
  try {
    return await userService.setUserLanguage(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SetCampus = createAsyncThunk('user-set-campuse', async (user: {}, thunkAPI) => {
  try {
    return await userService.setCampus({user})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// User Types
type UserState = {
  users: any
  user: any
  total_users: any
  total_roles: any
  total_permission: any
  errors: any
}

const initialState: UserState = {
  users: {
    data: [],
  },
  user: {},
  total_users: '',
  total_roles: '',
  total_permission: '',
  errors: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action: PayloadAction<any>) => {
        state.users = action.payload
      })
      .addCase(createUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUserPassword.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = userSlice.actions
export default userSlice.reducer
